import { useEffect } from 'react';

import { useRouter } from 'next/router';

import BorrowLendLayout from '@/components/dashboard/borrow-land/BorrowLendLayout';
import LendLoan from '@/components/dashboard/borrow-land/LendLoan';
import { Loader } from '@/components/Loader';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { fetchLendingOffers } from '@/redux/loans/loansSlice';

const LendLoanPage = () => {
  const { lendingLoading } = useAppSelector((state) => state.loans);
  const router = useRouter();
  const { sort, dir, searchTerm, currency } = router.query;

  const dispatch = useAppDispatch();
  useEffect(() => {
    const filters = {
      ...(sort && dir ? { sort, dir } : {}),
      ...(searchTerm ? { searchTerm } : {}),
      ...(currency ? { currency } : {}),
    };

    dispatch(fetchLendingOffers(filters));
  }, [dir, dispatch, sort, searchTerm, currency]);

  return (
    <BorrowLendLayout canClose title='Give a Loan' description='Browse loan requests, submit counteroffers, or lend directly to earn interest on your crypto. NettyWorth securely holds assets in a smart contract and transfers them to your wallet if the borrower defaults.'>
      {lendingLoading ? <Loader /> : <LendLoan />}
    </BorrowLendLayout>
  );
};

LendLoanPage.metadata = {
  title: 'NettyWorth | Earn High Returns by Lending Crypto',
  description: 'Maximize your earnings with NettyWorth’s loan marketplace. Lend your crypto to users borrowing against their Crypto, NFTs, and Gaming Assets. Earn high returns, generate passive income, and make informed lending decisions with NettyScore, a Web3 credit score that tracks borrower loan history.',
  image: `${process.env.NEXT_PUBLIC_SITE_URL}/thumbnail.png`,
  contentType: 'product',
};

LendLoanPage.signedInDesign = true;

export default LendLoanPage;
